import render from '../utils/render';

// For easier debugging
// window._____APP_STATE_____ = stores

render('finemark-login-root', true);

